import commApi from "@/api/apis/common.js";
import router from '@/router'
import md5 from 'js-md5';
import JSEncrypt from "jsencrypt";
import { setGlobalUserProfile } from "@/utils/qt.js";
export default {
  namespaced: true,
  state: {
    /** 内容类型 **/
    CONTENT_TYPE: {
      ACTIVITY: 1, // 活动
      ACTIVITY_SIGN: "activity_sign", //活动签到
      ACTIVITY_WORK_DETAIL: "activity_work_detail", //作品详情
      RAFFLE: 2, // 抽奖
      VOTE: 3, // 投票
      LIVE: 4, // 直播
      NEWS: 5, // 新闻
      GALLERY: 6, // 图集
      SPECIAL: 7, // 专题
      AD: 8, // 广告
      VIDEO: 9, // 视频
      QUESTIONNAIRE: 10, // 问卷调查
      AUDIO: 11, // 音频
      LINK: 12, // 外链
      REPORT: 16, // 报料
      REPORTLIST: 'report', //报料列表
      RE_QUESTION: 17, // 问答
      WE_MEDIA: "we-media", // 自媒体
      INVITE: "invite", // 邀请
      SPECIAL_CONTENT_LIST: "special_content_list", // 专题-更多稿件列表
      COLUMN: "column", // 专栏
    },
    PAGE: {
      ACTIVITY: "/activity_detail", // 活动详情
      ACTIVITY_SIGN: "/sign_in", //活动签到
      ACTIVITY_WORK_DETAIL: "entriy_detail", //作品详情
      RAFFLE: "/raffle_detail", // 抽奖详情
      VOTE: "/vote_detail", // 投票详情
      LIVE: "/live_detail", // 直播详情
      NEWS: "/news_detail", // 图文详情
      GALLERY: "/gallery_detail", // 图集详情
      SPECIAL: "/special_detail", // 专题首页
      AD: "/ad_detail", // 广告
      VIDEO: "/video_detail", // 视频详情
      SHORTVIDEO: "/short_video_detail", // 短视频详情
      QUESTIONNAIRE: "/questionnaire_detail", // 问卷调查
      ANSWER: "/answer_detail", // 答题
      AUDIO: "audio_detail", // 音频详情
      REPORT: "/report_detail", //报料详情
      REPORTLIST: "report_list", //报料列表
      RE_QUESTION: "/requestion_detail", // 问答详情
      WE_MEDIA: "/media_detail", // 自媒体详情
      INVITE: "invitation", // 邀请
      SPECIAL_CONTENT_LIST: "/special_more", //专题分类下内容列表页
      COLUMN: "/column_detail", // 专栏首页
    },
    nodeCode: process.env.VUE_APP_NODE_CODE, //企业code
    wxAppId: process.env.VUE_APP_WECHAT_APPID, //微信AppId
    shareRootUrl: process.env.VUE_APP_SHARE_URL, //分享页地址
    appName: process.env.VUE_APP_APP_NAME, //客户端名称
    appFullName: process.env.VUE_APP_APP_FULL_NAME, //客户端名称-全称
    userInfo: JSON.parse(window.localStorage.getItem("fz-share-userInfo")),
    deviceId: window.localStorage.getItem("fz-share-deviceId"),
  },
  mutations: {
    SET_TOKEN(state, data) {
      state.token = data;
      window.localStorage.setItem("fz-share-accessToken", data.access_token);
      window.localStorage.setItem("fz-share-refreshToken", data.refresh_token);
      window.localStorage.setItem("fz-share-expiresIn", data.expires_in);
      window.localStorage.setItem("fz-share-tokenType", data.token_type);
      let curTimeStamp = new Date().getTime();
      window.localStorage.setItem("fz-share-tokenTime", curTimeStamp);
    },
    SET_USERINFO(state, data) {
      state.userInfo = data;
      window.localStorage.setItem("fz-share-userInfo", JSON.stringify(data));
      if (data && data.id) {
        setGlobalUserProfile({
          id: data.id,
          registrationSource: data.registrationSource || data.registration_source,
          gender: data.gender,
          age: data.age,
          firstAccountRegistDate: data.firstAccountRegistDate || data.first_account_regist_date,
        });
      }
    },
    SET_DEVICEID(state, data) {
      state.deviceId = data;
      window.localStorage.setItem("fz-share-deviceId", data);
    }
  },
  actions: {
    setUserInfo({ commit }, data) {
      commit('SET_USERINFO', data)
    },
    setDeviceId({ commit }, data) {
      commit('SET_DEVICEID', data)
    },
    GetToken({ commit, dispatch, state }, data) {
      return new Promise((resolve, reject) => {

        var deviceId = window.localStorage.getItem("fz-share-deviceId");

        var params = {
          client_id: process.env.VUE_APP_CLIENT_ID,
          client_secret: process.env.VUE_APP_CLIENT_SECRET,
          username: process.env.VUE_APP_USERNAME,
          grant_type: process.env.VUE_APP_GRANT_TYPE,
          password: "",
          verifyCodeType: 0, // 0不进行验证码验证,1短信验证码,2图片验证码
          platformFlag: 0, // 0.匿名登录，1.手机号密码登录，2.手机号短信验证码登录 ,3.微信，4.QQ，5.微博,6.苹果账号
          appCode: process.env.VUE_APP_APP_CODE, // 终端号。每个APP终端唯一。
          time: new Date().getTime(),
          nodeCode: process.env.VUE_APP_NODE_CODE,
          version: process.env.VUE_APP_VERSION,
        }

        if (!!data && data.platformFlag == 2) {
          params.verifyCodeType = 1;
          params.platformFlag = 2;
          params.username = data.mobilePhone;
          params.password = "";
          params['verifyCode'] = data.authCode;
        } else {
          params.verifyCodeType = 0;
          params.platformFlag = 0;
          params.username = process.env.VUE_APP_USERNAME;
          params.password = deviceId;

          // 生成sign
          var str = params.client_id + params.client_secret + params.username + params.password + params.grant_type + params.verifyCodeType + params.nodeCode + params.platformFlag + params.time + params.appCode;
          params['sign'] = md5(str);

          // password Rsa非对称加密
          let jse = new JSEncrypt();
          jse.setPublicKey(process.env.VUE_APP_PUBLIC_KEY);
          params.password = jse.encrypt(params.password);
        }

        commApi.getToken(params).then((res) => {
          if (Object.prototype.hasOwnProperty.call(res, "access_token")) {
            commit('SET_TOKEN', res);
            resolve(res);
          } else {
            window.localStorage.removeItem("fz-share-userInfo");
            window.localStorage.removeItem("fz-share-accessToken");
            window.localStorage.removeItem("fz-share-refreshToken");
            window.localStorage.removeItem("fz-share-expiresIn");
            window.localStorage.removeItem("fz-share-tokenType");
            window.localStorage.removeItem("fz-share-tokenTime");
            reject(res);
          }
        }).catch(err => {
          console.log('err', err);
          reject(err);
        });
      });
    },
    RefreshToken({ commit, dispatch, state }) {
      return new Promise((resolve, reject) => {
        var refreshToken = window.localStorage.getItem("fz-share-refreshToken");
        var params = {
          grant_type: 'refresh_token',
          client_id: process.env.VUE_APP_CLIENT_ID,
          client_secret: process.env.VUE_APP_CLIENT_SECRET,
          refresh_token: refreshToken,
        };
        commApi.getToken(params).then((res) => {
          if (Object.prototype.hasOwnProperty.call(res, "access_token")) {
            commit('SET_TOKEN', res);
            resolve(res);
          } else {
            window.localStorage.removeItem("fz-share-userInfo");
            window.localStorage.removeItem("fz-share-accessToken");
            window.localStorage.removeItem("fz-share-refreshToken");
            window.localStorage.removeItem("fz-share-expiresIn");
            window.localStorage.removeItem("fz-share-tokenType");
            window.localStorage.removeItem("fz-share-tokenTime");
            console.log(res);
            // router.push('/login');
            window.location.reload();
          }
        }).catch(err => {
          console.log('err', err);
          if (err.responseJSON.error == "401" || err.responseJSON.error == 401) {
            window.localStorage.removeItem("fz-share-userInfo");
            window.localStorage.removeItem("fz-share-accessToken");
            window.localStorage.removeItem("fz-share-refreshToken");
            window.localStorage.removeItem("fz-share-expiresIn");
            window.localStorage.removeItem("fz-share-tokenType");
            window.localStorage.removeItem("fz-share-tokenTime");
            // router.push('/login');
            window.location.reload();
          } else {
            reject(err);
          }
        });
      });
    },
  },
  modules: {

  }
}